import { globalState } from './globalState'
import { createCxfEventHandlers } from './handlers/cxfEventHandlers'
import { createPostMessageHandlers } from './handlers/postMessageHandlers'
import { ICXF } from './types/cxf'
import { log, tryCatch } from './utils'

export const app = (cxf: ICXF): void => {
    const postMessageHandlers = createPostMessageHandlers()
    const subscribeCxf = createCxfEventHandlers()

    window.addEventListener(
        'message',
        tryCatch(({ data }: MessageEvent) => {
            if (data) {
                const handler = postMessageHandlers[data.name]
                if (handler) {
                    log('POST MESSAGE', data)
                    handler(data.payload)
                }
            }
        })
    )

    // Subscribe to all CXF events
    for (const handler of subscribeCxf) {
        handler(cxf)
    }

    globalState.preResolveConfig()
    log('App has started')
}
